import { createContext, useContext, useEffect, useState } from "react";
import ActivityItems from "../components/ActivityItems";
import ActivityNav from "../components/ActivityNav";
import itemService from "../services/ItemService";
export const activityContext = createContext();
const Dashboard = () => {
  const [itemActivity, setItemActivity] = useState(null);
  const [isUpdateActivity, setIsUpdateActivity] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const toogleActivity = () => setIsUpdateActivity(!isUpdateActivity);

  const fetchData = async () => {
    const res = await itemService.getDataAll();
    setItemActivity(res.data);
    setIsUpdateActivity(false);
  };
  const addActivity = async () => {
    setIsLoading(true);
    const res = await itemService.createActivity();
    if (res.status == 201) {
      toogleActivity();
      setIsLoading(!isLoading);
    }
  };
  useEffect(() => {
    isUpdateActivity && fetchData();
  }, [isUpdateActivity]);

  const contextValue = {
    addActivity,
    isLoading,
    toogleActivity,
    isUpdateActivity,
  };
  return (
    <activityContext.Provider value={contextValue}>
      <section className="flex flex-col nowrap">
        <nav>
          <ActivityNav />
        </nav>
        <article>
          <ActivityItems fetchActivity={fetchData} activity={itemActivity} />
        </article>
      </section>
    </activityContext.Provider>
  );
};

export default Dashboard;
